import { getDatesBetween } from "./handles";
import { useRef, useState } from "react";
import { dateFormat } from "components/utils/comm";
import Calenader from "./calendar";
import { useTranslation } from "react-i18next";
import "./datepick.scss";

export interface IProps {
  txt?: string;
  startNm: string;
  endNm: string;
  defaultValue?: Array<string>;
  onPickDate?: (dates: Array<string>) => void;
}

export default function DatePick({
  txt = "txt_date_range",
  startNm,
  endNm,
  defaultValue = [],
  onPickDate,
}: IProps) {
  const { t } = useTranslation();

  const datePickRef = useRef<HTMLDivElement>(null);
  const calendarRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [range, setRange] = useState<Array<string>>([]);

  const dateRange = getDatesBetween(
    dateFormat(defaultValue[0]),
    dateFormat(defaultValue[1])
  );

  return (
    <div className="date-pick" ref={datePickRef}>
      <div className="flex h-full">
        <label htmlFor="">{t(txt)}</label>
        <input
          type="text"
          className="h-full cursor-pointer"
          name={startNm}
          data-type="C"
          value={dateFormat(defaultValue[0])}
          readOnly
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        />
        <span className="w-[10px] text-center">-</span>
        <input
          type="text"
          className="h-full cursor-pointer"
          name={endNm}
          data-type="C"
          value={dateFormat(defaultValue[1])}
          readOnly
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        />
      </div>
      {isOpen && (
        <Calenader
          datePickRef={datePickRef}
          calendarRef={calendarRef}
          range={range}
          dateRange={dateRange}
          setRange={setRange}
          onPickDate={onPickDate}
        />
      )}
    </div>
  );
}
